// Back to top (sections/ns-back-to-top.liquid; 07 Interactive Prototype "BACK TO TOP", gap inventory 2026-10-18 #19). The button
// shows once the page is scrolled past 900 px, as in the prototype. A press scrolls to the top, smoothly unless reduced motion
// is asked for, and gives focus to the main content so the keyboard starts from the top too.
export const shouldShow = y => Number(y) > 900;

export function initBackToTop(doc, { view = doc.defaultView } = {}) {
  for (const button of doc.querySelectorAll('[data-ns-back-to-top]')) {
    if (button.dataset.nsReady) continue;
    button.dataset.nsReady = '1';
    const sync = () => { const show = shouldShow(view?.scrollY ?? 0); if (button.hidden === show) button.hidden = !show; };
    view?.addEventListener?.('scroll', sync, { passive: true });
    button.addEventListener('click', () => {
      const reduce = view?.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false;
      view?.scrollTo?.({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
      doc.getElementById('MainContent')?.focus({ preventScroll: true });
    });
    sync();
  }
}

if (typeof document !== 'undefined') {
  const start = () => initBackToTop(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
}
